{
    "coordinates": [
        43.43539345541092,
        112.15701558512575
    ],
    "tooltip": "Irdin",
    "title": "Irdin Manha Formation",
    "country": "China",
    "period": "Paleogene",
    "alt": "TODO"
}
